import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDialogClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 11.2014L17.0508 6.65063L17.8994 7.49927L13.3486 12.05L17.748 16.4495L16.8994 17.2981L12.5 12.8987L8 17.3987L7.15137 16.55L11.6514 12.05L7 7.39868L7.84863 6.55005L12.5 11.2014Z",
		fill: "currentColor"
	})
});
export default SvgIconDialogClose;
